module.exports = __webpack_public_path__ + "media/images/icons/country_flags/hr-bca499f7170de072e4c412a91efa5c91.svg";